export default "__VITE_ASSET__C3Yvgdof__"